import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { NavParams } from 'ionic-angular';
import { EventProvider } from '../../providers/event/event';
import { GlobalUtil } from '../../tracker/global-utils';
import { GpsTracker } from '../../tracker/gps-tracker';

@Component({
    selector: 'inbrowser',
    templateUrl: 'inbrowser.html',
})
export class InBrowserPage {
    url;

    constructor(private navParams: NavParams, private eventService: EventProvider, private sanitizer: DomSanitizer) {
        console.log('ionView')


        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(navParams.get("link"));
        console.log('this.url: ', this.url);
    }

    ionViewWillLeave() {
        console.log('ionViewWillLeave: ');
        // this.eventService.onBackPage(GlobalUtil.getInstance().currentEventID).then(res => console.log(res));
    }


}



// WEBPACK FOOTER //
// /src/pages/browser/inbrowser.ts